import { render, staticRenderFns } from "./SafetyManagerManage_new.vue?vue&type=template&id=71cad7e8&"
import script from "./SafetyManagerManage_new.vue?vue&type=script&lang=js&"
export * from "./SafetyManagerManage_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports